import type { TerritoryDto } from '@rw/shared';
import { create } from 'zustand';

interface Flash {
  gridKey: string;
  color: string;
  at: number;
}

interface TerritoryLiveState {
  /** Ownership updates received in realtime, newer than the last fetch. */
  overrides: Record<string, TerritoryDto>;
  flashes: Flash[];
  version: number;
  apply: (t: TerritoryDto) => void;
  flash: (gridKey: string, color: string) => void;
  reset: () => void;
}

export const useTerritoryLive = create<TerritoryLiveState>((set, get) => ({
  overrides: {},
  flashes: [],
  version: 0,
  apply: (t) => set({ overrides: { ...get().overrides, [t.gridKey]: t }, version: get().version + 1 }),
  flash: (gridKey, color) => {
    const now = Date.now();
    set({ flashes: [...get().flashes.filter((f) => now - f.at < 6000), { gridKey, color, at: now }], version: get().version + 1 });
  },
  reset: () => set({ overrides: {}, version: get().version + 1 }),
}));
